<template>
    <div class="bottom" :class="{'selectt': infoReseauxNumerique.select}">
      <div class="container_img_info">
        <img :src="url" class="imageBg" alt="">
        <div class="dot_select" @click="contolSelect()"
          :class="{'dot_select1': infoReseauxNumerique.select}">
          <div class="dot_selected" v-if="infoReseauxNumerique.select"></div>
        </div>
        <div @click="show = true" class="level is-mobile bgBlur">
          <div class="has-text-white">
            <div
              v-if="infoReseauxNumerique.extensionOpportunite.quantite"
              class="media">
              <b-icon
                icon="timer"
                size="is-medium"
                class="media-left margin_small">
              </b-icon>
              <div class="media-content is-size-7">
                <label>Durée:</label><br>
                <label class="has-text-weight-bold">
                  {{formatDureeNum(infoReseauxNumerique.extensionOpportunite.typeTarification,
                    infoReseauxNumerique.extensionOpportunite.quantite)}}
                </label>
              </div>
            </div>
          </div>
          <div
            class="level-right"
            v-if="tarif">
            <h3 class="has-text-weight-bold has-text-white goToLeft">
              {{formatNum(tarif)}}
            </h3>
          </div>
        </div>
      </div>
      <div @click="show = true" class="has-background-white infoBorder">
        <div class="level is-marginless">
          <div class="topViolet leftViolet bottomVert">
            <p class="is-size-7">
              <label class="has-text-default">Nom du réseau</label><br>
              <strong class="p_size12 has-text-link">
                {{infoReseauxNumerique.libelle}}
              </strong>
            </p>
          </div>
        </div>
        <div class="column leftViolet rightViolet">
          <div class="columns is-multiline is-mobile color-icon">
            <div class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="city"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Ville </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxNumerique.ville}}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="vector-intersection"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Format </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxNumerique.format}}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="column bottomVert is-paddingless is-6">
              <div class="media">
                <b-icon
                  icon="sign-text"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Nombre de d'écrans </label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{infoReseauxNumerique.nbFaces}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-6"
                 v-if="infoReseauxNumerique.extensionOpportunite.typeTarification">
              <div class="media">
                <b-icon
                  icon="cellphone-screenshot"
                  size="is-medium"
                  class="media-left">
                </b-icon>
                <div class="media-content is-size-7">
                  <label class="has-text-default">Mode de diffusion</label><br>
                  <p class="p_size12 has-text-link has-text-weight-bold">
                    {{modeDiff(infoReseauxNumerique.extensionOpportunite.typeTarification)}}
                  </p>
                </div>
              </div>
            </div>
            <div class="column bottomVert is-paddingless is-12"
              v-if="infoReseauxNumerique.extensionOpportunite.commentaire">
              <div class="media">
                <div class="media-content">
                    <label class="has-text-weight-bold has-text-link p_size14">
                      Commentaire : </label><br>
                    <p class="p_size12 has-text-default has-text-link">
                      {{infoReseauxNumerique.extensionOpportunite.commentaire}}
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a>
          <p class="p_size14 has-text-centered has-text-white color-plus-info">
            Plus d'informations
          </p>
        </a>
      </div>
      <app-detail-reseaux-numerique-complet-diapo
        :detailResauxComplet="infoReseauxNumerique"
        v-if="show"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { formatNum, urlPhoto, formatDureeNum, modeDiff } from '@/services/opportunite/formatTab';
import detailReseauxNumeriqueCompletDiapo from './detailReseauxNumeriqueCompletDiapo';

export default {
  name: 'infoReseauxNumerique',
  props: ['infoReseauxNumerique'],
  components: {
    appDetailReseauxNumeriqueCompletDiapo: detailReseauxNumeriqueCompletDiapo,
  },
  data() {
    return {
      show: false,
      bg: false,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.infoReseauxNumerique.urlPhoto);
    },
    tarif() {
      if (this.infoReseauxNumerique.extensionOpportunite.tarifNet) {
        return this.infoReseauxNumerique.extensionOpportunite.tarifNet;
      }
      return this.infoReseauxNumerique.extensionOpportunite.tarifHt;
    },
  },
  methods: {
    ...mapActions([
      'add',
      'substract',
      'addNbSelect',
      'substractNbSelect',
    ]),
    contolSelect() {
      this.infoReseauxNumerique.select = !this.infoReseauxNumerique.select;
      if (this.infoReseauxNumerique.select) {
        this.add(this.tarif);
        this.addNbSelect();
      } else {
        this.substract(this.tarif);
        this.substractNbSelect();
      }
    },
    modeDiff(t) {
      return modeDiff(t);
    },
    formatDureeNum(t, q) {
      return formatDureeNum(t, q);
    },
    formatNum(value) {
      return formatNum(value);
    },
  },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxNumeriques/infoReseauxNumerique.vue